export const impactLevelCategories = {
  BUSINESS: 'Business level',
  PRODUCT: 'Product level',
  PARTNER: 'Partner level',
  COMPONENT: 'Component level',
};
